export function Label({ children, htmlFor }) {
  return (
    <label htmlFor={htmlFor} className="block text-xs font-mono uppercase tracking-[0.15em] text-ink/60 mb-1.5">
      {children}
    </label>
  );
}

const baseInput =
  "w-full rounded-xl border border-terracotta/20 bg-white px-4 py-2.5 text-sm text-ink placeholder:text-ink/35 outline-none focus:ring-2 focus:ring-terracotta/40 focus:border-terracotta transition";

export function Input({ className = "", ...props }) {
  return <input {...props} className={`${baseInput} ${className}`} />;
}

export function Textarea({ className = "", ...props }) {
  return <textarea {...props} className={`${baseInput} min-h-[96px] resize-y ${className}`} />;
}

export function Select({ className = "", children, ...props }) {
  return (
    <select {...props} className={`${baseInput} appearance-none ${className}`}>
      {children}
    </select>
  );
}

export function PrimaryButton({ className = "", children, ...props }) {
  return (
    <button
      {...props}
      className={`rounded-full bg-terracotta text-sand px-6 py-3 text-sm font-semibold hover:bg-terracotta-dark transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 ${className}`}
    >
      {children}
    </button>
  );
}

export function GhostButton({ className = "", children, ...props }) {
  return (
    <button
      {...props}
      className={`rounded-full border border-ink/15 px-6 py-3 text-sm font-semibold text-ink hover:border-terracotta hover:text-terracotta transition-colors flex items-center justify-center gap-2 ${className}`}
    >
      {children}
    </button>
  );
}
